import { Button } from 'devextreme-react/button';
import { Item, Toolbar } from 'devextreme-react/toolbar';
import DataGrid, { Column, Paging } from 'devextreme-react/data-grid';
import { useContext, useState } from 'react';
import { AR, FileTypes, KindOfOrder } from '../../../../types/enums';
import { FileAttachmentLink, FileAttachmentsPopup } from '../../../common';
import { RefetchScope, PurchaseOrderContext } from '../context/PurchaseOrderContext';

export default function PurchaseOrderInvoiceFiles() {

	const { order, refetchOrder } = useContext(PurchaseOrderContext);
	const [isPopupVisible, setPopupVisibility] = useState(false);

	return (
		<>
			<>
				{
					<>
						<Toolbar className='button-toolbar'
							visible={order.details.activeARs.includes(AR.PODistributorToInvoice) ||
								order.details.activeARs.includes(AR.POServiceProviderToInvoice)}>
							<Item location={'before'} >
								<Button
									text="Upload Invoice"
									icon="Inscyth-Add"
									width={220} onClick={() => setPopupVisibility(true)}>
								</Button>
							</Item>
						</Toolbar>

						<FileAttachmentsPopup
							attachedFiles={order.details.files}
							orderID={order.details.purchaseOrderID}
							parentGuid={order.details.guid}
							kindOfOrder={KindOfOrder.PurchaseOrder}
							defaultFileType={FileTypes.DistributorInvoice}
							useFileTypes={true}
							onFileAdded={(fileType: FileTypes) => {
								refetchOrder(RefetchScope.Files);

								if (fileType === FileTypes.DistributorInvoice) {
									setPopupVisibility(false);
								}
							}}
							onFileDeleted={() => refetchOrder(RefetchScope.Files)}
							onPopupHidden={() => setPopupVisibility(false)}
							visible={isPopupVisible}
						/>
					</>
				}
			</>

			{
				order.details.files.some(x => x.fileTypeID === FileTypes.DistributorInvoice) &&
				<DataGrid
					className='dx-card wide-card'
					dataSource={order.details.files.filter(x => x.fileTypeID === FileTypes.DistributorInvoice)}
					allowColumnResizing={true}
					showBorders={true}
					showColumnLines={true}
					columnAutoWidth={true}
					keyExpr={'documentID'}
				>
					<Paging enabled={false} />

					<Column
						caption={'File Name'}
						dataType="string"
						cellRender={(cell: any) => {
							return <FileAttachmentLink
								caption={cell.data.fileName}
								fileName={cell.data.fileName}
								awsS3Key={cell.data.awsS3Key} />
						}}
					>
					</Column>
					<Column
						dataField={'fileTypeName'}
						caption={'File Type'}
						dataType="string"
					/>
					<Column
						dataField={'uploadDate'}
						caption={'Upload Date'}
						dataType="date"
						format="shortDateShortTime"
					/>
					<Column
						dataField={'createdBy'}
						caption={'Created By'}
						dataType="string"
					/>
				</DataGrid>
			}
		</>
	);
}
